import formatPropertyName from "utils/column/formatPropertyName";
import getColumnLabelWithContext from "utils/column/getColumnLabelWithContext";
import getGroupByListColumnByProperty from "utils/column/getGroupByListColumnByProperty";

import { IGroupByListItem } from "models/groupBy";

import { MlFeature, MlTarget } from "components/ml/types";

/**
 * Gets the display name for an ML feature or target using column metadata.
 * Returns formatted name with product prefix and units from the column's title.
 *
 * @param item - The ML feature or target
 * @param categoryList - The category list containing column metadata
 * @param unitType - Optional unit type for fallback unit resolution
 * @returns Formatted display name with product prefix and units
 */
export function getMlFeatureDisplayName(
  item: MlFeature | MlTarget,
  categoryList: IGroupByListItem[],
  unitType?: number
): string {
  if (!item) return "";

  const col = getGroupByListColumnByProperty(
    categoryList,
    formatPropertyName(item.Property)
  );

  if (!col) {
    // Fallback: format with available unit information
    const unit = (item as MlTarget).AllUnits?.[unitType ?? 0] ?? item.Unit;

    // Check if NiceName already contains the unit in parentheses
    if (unit && !item.NiceName.includes(`(${unit})`)) {
      return `${item.NiceName} (${unit})`;
    }

    return item.NiceName;
  }

  // Global normalization doesn't apply in ML context
  const contextTitle = getColumnLabelWithContext(col, false, undefined);

  return contextTitle.fullContextTitle || item.NiceName;
}
